import * as _ from 'lodash';
import localStore from 'src/utils/local-storage'
import fetch from 'cross-fetch';
import ApiService from "../services/ApiService";

const probe = require("probe-image-size");
const default_length = 0;
const title_length = 105;
const google_length = 70;
const google_content_length = 160;
const tag_length = 3;

const REACT_APP_UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
const DOMAIN = process.env.REACT_APP_INTERNAL_DOMAIN.split(',');
const cdnRegex = RegExp(DOMAIN.map(s => s.trim().replace('.', '\\.')).join('|'));
const cdnRegexExternalLink = new RegExp(
  DOMAIN.map(s => `^(https?:\/\/)?(www\\.)?${s.trim().replace(/\./g, '\\.')}(\/|$)`).join('|')
);

function getFirstVideoURL(content) {
  let pattern = content.match(/(?:(?:https?|http):\/\/)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm);
  let firstVideoURL = "";

  if (pattern) {
    pattern.forEach(content => {
      if (content.includes(".mp4") || content.includes(".m3u8") || content.includes("youtube.com") || content.includes("youtu.be") || content.includes("facebook.com")) {
        firstVideoURL = content;
        return firstVideoURL;
      }
    });
  }

  return firstVideoURL;
}

async function getSizeVideoSS(url){
  
  if(url && url.indexOf("saostar.vn") > 0){
    
    let urlThumb = url.replace("img.saostar.vn","ss-thumb.saostar.vn");
    urlThumb = urlThumb.replace('cdn-media.saostar.vn', 'ss-thumb.saostar.vn');
    urlThumb = urlThumb.replace('betacms.saostar.vn', 'ss-thumb.saostar.vn');
    urlThumb = urlThumb.replace('video.saostar.vn', 'ss-thumb.saostar.vn');
    urlThumb = urlThumb.replace('ss-images.saostar.vn', 'ss-thumb.saostar.vn');
    urlThumb = urlThumb.replace(/(\?duration=.*)/gm,'');
    urlThumb = `${urlThumb}/thumb-2000.jpg`;

    if (urlThumb) {
      try {
        let infoImg = await probe(encodeURI(urlThumb), { timeout: 5000 });
        if (!infoImg) {
          return null;
        }
        return infoImg;
      } catch (error) {
        console.log("ERR get Thumb Info Width Height Video SS:", error);
      }
    }
    
  }
  return null;
}

async function getSizeYoutube(url){
  const youtubeID = url.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/i);
  let data = null;
  if(youtubeID && youtubeID.length > 0 && window){
    try{
      data = await ApiService.get(`/posts/youtube/${youtubeID[1]}`).then(data => {
        if (data) {
          return data;
        } 
      });
    }
    catch(error){
      console.log(error);
    }
  }
  return data.data;
  // return data;
}

async function getSizeFacebook(url){
  let data = null;
  if(window && url){
    try{
      data = await ApiService.get(`/posts/facebook/${encodeURIComponent(url)}`).then(data => {
        if (data) {
          // console.log(data);
          return data;
        }
      });
    }
    catch(error){
      console.log(error);
    }
  }
  return data.data;
}

function checkSubTitle(content){
  const h3TagRegex = /<h3[^>]*>(.*?)<\/h3>/g;
  const count = (content.match(h3TagRegex) || []).length;
  return count >= 1;
}

function checkKeyword({keyword, title, title_google, description, description_google}){
  if(!keyword) return true;

  let keywordLowercase = keyword.toLowerCase();
  if (title && !title.toLowerCase().includes(keywordLowercase)) return true;
  if (title_google && !title_google.toLowerCase().includes(keywordLowercase)) return true;
  if (description && !description.toLowerCase().includes(keywordLowercase)) return true;
  if (description_google && !description_google.toLowerCase().includes(keywordLowercase)) return true;

  return false
}

//This function checks
// if the number of internal links in a given HTML string that point to 'saostar.vn'
// is within a specific range(1 to 3, inclusive).
function checkInternalLink(data) {
  const regex = /<a\s+[^>]*href="([^"]*)"[^>]*>/gi;
  const matches = [...data.matchAll(regex)];
  let checkLinkError = false;
  console.log("checkInternalLink");
  const internalLinks = matches.filter(match => {
    const href = match[1];
    console.log({href});
    // Bỏ qua các link tương đối (không có http hoặc https)
    if (!/^https?:\/\//i.test(href)) {
      checkLinkError = true;
      return false;
    }

    try {
      const url = new URL(href);
      const hostname = url.hostname.toLowerCase();

      return hostname === 'saostar.vn' ||
             hostname === 'www.saostar.vn' ||
             hostname === 'showbiz.vn'
    } catch (e) {
      return false;
    }
  });
  if(checkLinkError) {
    console.log("Bạn chèn link lỗi");
    return 0;
  }
  const count = internalLinks.length;
  return count;
}

function checkExternalLink(data) {
  // group 1 = quote, group 2 = URL
  const regex = /<a[^>]* href=(['"])(.*?)\1/gi;
  const matches = Array.from(data.matchAll(regex));
  
  // Trả về true nếu có ít nhất 1 link không thuộc domain nội bộ
  return matches.some(match => {
    const href = match[2].trim();
    try {
      const url = new URL(href, 'https://www.saostar.vn'); // resolve relative URL
      const fullURL = url.href;
      return !cdnRegexExternalLink.test(fullURL);
    } catch (e) {
      // Nếu không phải URL hợp lệ hoặc là relative URL ("/abc"), ta xem là external
      return true;
    }
  });
}

function checkExternalIMG(data) {
  // group 1 = single / double quote
  // group 2 = href value
  const regex = /<img[^>]* src=(['"])(.*?)\1>/g;
  const matches = Array.from(data.matchAll(regex));
  return !!matches.filter(match => !cdnRegex.test(match[2])).length;
}

function checkNhayCam(data) {
  // NOTE: còn lỗi trường hợp
  // - từ nhạy cảm là 1 html tag
  let tu_nhay_cam = [];
  if (localStore.getE("_banword")) {
    tu_nhay_cam = _.split(localStore.getE("_banword"), ",").map((w) =>
      w.trim().toLocaleLowerCase()
    );
  }
  const vn =
    "àáãạảăắằẳẵặâấầẩẫậèéẹẻẽêềếểễệđìíĩỉịòóõọỏôốồổỗộơớờởỡợùúũụủưứừửữựỳỵỷỹýÀÁÃẠẢĂẮẰẲẴẶÂẤẦẨẪẬÈÉẸẺẼÊỀẾỂỄỆĐÌÍĨỈỊÒÓÕỌỎÔỐỒỔỖỘƠỚỜỞỠỢÙÚŨỤỦƯỨỪỬỮỰỲỴỶỸÝ";
  const bannedWordsRegex = new RegExp(
    `([^a-zA-Z\\d${vn}])(${tu_nhay_cam.join("|")})(?=[^a-zA-Z\d${vn}]|$)`,
    "gi"
  );

  const matches = data.match(bannedWordsRegex);
  if (matches) {
    // console.log(`Từ nhạy cảm:`, matches);
    const m = matches.map(mat => mat.substring(1));
    return m;
  }
  return false;
}

function strip_tags(input, allowed) {
  allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
  const tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
  return input.replace(tags, ($0, $1) => (allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''))
}

const checkCondition = async (props) => {
  const { type, content: { title, title_google, url, keyword, description, description_google,
    content, img_ver, img_hor, categories, tags, contentpenname, primary_category, pr_type, royalties_editor, editor_type, video_url, dimensions, prprice, prdiscount, pragency }, ignoreList } = props;
  let isFalse = false;
  const _user = localStore.get('_user');

  switch (type) {

    case 'title':

      if (title && title_google && url && keyword) {
        if ((title.length === default_length) || (title_google.length > google_length || title_google.length === default_length) || url.length === default_length || keyword.length === default_length) {
          if (_user.no_banword && pr_type > 0 && title.length !== default_length && title_google.length !== default_length && title_google.length !== default_length &&  url.length !== default_length && keyword.length !== default_length) {
            return false;
          } else {
            return true
          }
        }
      } else {
        return true;
      }
      break;
    case 'title_google':
      if(title_google){
        if((title_google.length > google_length) || (title_google.length === default_length)){
          return {
            error: true,
            info: 'title_google is empty or too long',
          }
        }
        return false
      }
      return {
        error: true,
        info: 'title_google is empty',
      }
    case 'keyword':
      const isErrorKeyword = checkKeyword({keyword, title, title_google, description, description_google});
      if(isErrorKeyword){
        return {
          error: true,
          info: 'keyword is not in title or description',
        }
      }

      return false;
    case 'description':
      if ((!description || (description && description.length == default_length || (!description_google || (description_google && description_google.length > google_content_length))))) {
        return true
      }
      break;
    case 'description_google':
      if(description_google){
        if((description_google.length > google_content_length) || (description_google.length === default_length)){
          return {
            error: true,
            info: 'description_google is empty or too long',
          }
        }
        return false
      }
      return {
        error: true,
        info: 'description_google is empty',
      }
    case 'content':
      if (content.length == default_length) {
        return true
      }

      break;
    case 'content_sub_title':
      const isExistSubTitle = checkSubTitle(content);
      if(!isExistSubTitle){
        return {
          error: true,
          info: 'Sub title - Sub heading is required',
        }
      }
      return false;
      break;
    case 'contentlink':
      // return true = chua noi dung ngoai => khong thoa dieu kien
      const externalContent = checkExternalLink(content);
      if (externalContent) {
        if (_user.can_pr && pr_type > 0) {
          // console.log('Bài viết chứa nội dung ngoài và user có quyền viết bài PR')
          return false
        }
        return true;
      }
      return false;
      break;
    case 'content_internal_link':
      const internalContent = checkInternalLink(content);
      if (internalContent < 1 || internalContent > 3) {
        if (_user.can_pr && pr_type > 0) {
          // console.log('Bài viết chứa nội dung ngoài và user có quyền viết bài PR')
          return false
        }
        return true;
      }
      return false;
      break;
    case 'externalimage':
      // return true = chua noi dung ngoai => khong thoa dieu kien
      const externalIMG = checkExternalIMG(content);
      if (externalIMG) {
        if (_user.can_pr && pr_type > 0) {
          // console.log('Bài viết chứa nội dung ngoài và user có quyền viết bài PR')
          return false
        }
        // console.log('Bài viết chứa nội dung ngoài')
        return true;
      }
      return false;
      break;
    case 'nhaycam':
      const check = checkNhayCam([title, description, content].join(' '));
      if (check) {
        if (_user.no_banword && pr_type > 0) {
          return false;
        } else {
          return {error: true, info: check};
        }
      }
      break;
    case 'thumbnail':
      if (img_ver.length == default_length || img_hor.length == default_length) {
        return true
      }
      break;
    case 'category':
      if ((categories && categories.length == default_length) || !primary_category) {
        return true
      }
      break;

    case 'tag':
      if (tags && tags.length < tag_length) {
        return true
      }
      break;
    case 'penname':
      if (!ignoreList.includes("penname")) {
        if (!contentpenname || (contentpenname && contentpenname.length === 0)) {
          return true
        }
      }
      break; 
    case 'money':
      return !royalties_editor;
      break;
    case 'pr':
      if (!ignoreList.includes("pr")) {
        // Bài pr bắt buộc phải để giá tiền, có thể có hoặc không có discount
        if (pr_type > 0 && (!pragency || (!prprice || (prprice && prprice === 0)))) {
          return true
        }
      }
      break;
    case 'videoratio':
      if (ignoreList.includes("videoratio")) {
        return false;
        break;
      }
      if(editor_type == 'video' || editor_type == 'short'){
        const video_url = getFirstVideoURL(content);
        console.log('check condition video');
        console.log(video_url);
        if(!video_url || video_url == ''){
          return true;
          break;
        }
        
        let videoInfo = null;
        try{
          if(video_url.indexOf("saostar.vn") > 0){              
            videoInfo = await getSizeVideoSS(video_url);
            console.log("Check video saostar");
            console.log(videoInfo);
            if(videoInfo && (videoInfo.width/videoInfo.height >= 1) && editor_type == 'video'){
              return false;
              break;
            }
            if(videoInfo && (videoInfo.height/videoInfo.width >= 1) && editor_type == 'short'){
              return false;
              break;
            }
            return true;
            break;
          }
          else{
            if(video_url.indexOf("facebook.com") > 0){
              videoInfo = await getSizeFacebook(video_url);
              console.log("Check video facebook");
              // console.log(video_url);
              console.log(videoInfo);
              if(videoInfo && (videoInfo.width/videoInfo.height >= 1) && editor_type == 'video'){
                return false;
                break;
              }
              if(videoInfo && (videoInfo.height/videoInfo.width >= 1) && editor_type == 'short'){
                return false;
                break;
              }
              return true;
              break;
            }
            else{
              videoInfo = await getSizeYoutube(video_url);
              console.log("Check video youtube");
              console.log(videoInfo);
              if(videoInfo && (videoInfo.width/videoInfo.height >= 1)  && editor_type == 'video'){
                return false;
                break;
              }
              if(videoInfo && (videoInfo.height/videoInfo.width >= 1)  && editor_type == 'short'){
                return false;
                break;
              }
              return true;
              break;
            }
            
          }
        }
        catch(error){
          console.log("ERROR Get Size Video");
        }
        return true;
        break;
      }
      else{
        return true;
        break;
      }
      return true;
      break;
  
    default:
      isFalse = false;
      break;
  }
  return isFalse;
}

export default checkCondition

